import { useEffect, useState } from "react";

import { supabase } from "~/integrations/supabase/client";
import { SalesRequest } from "~/types/client";

export const useFacturaNumbers = (orders: SalesRequest[]) => {
  const [facturaNumbers, setFacturaNumbers] = useState<Record<string, string>>(
    {}
  );
  const [facturaEmissionDates, setFacturaEmissionDates] = useState<
    Record<string, number>
  >({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFacturaNumbers = async () => {
      if (orders.length === 0) return;

      setLoading(true);
      try {
        const salesRequestIds = orders.map((order) => order.id);

        const { data, error } = await supabase
          .from("sales_request_documents")
          .select("sales_request_id, bsale_number, emission_date")
          .in("sales_request_id", salesRequestIds)
          .eq("document_type", "factura")
          .eq("cancelled", false);

        if (error) throw error;

        const facturaMap: Record<string, string> = {};
        const emissionDateMap: Record<string, number> = {};
        if (data) {
          data.forEach((doc) => {
            if (doc.sales_request_id && doc.bsale_number) {
              facturaMap[doc.sales_request_id] = doc.bsale_number;
            }
            if (doc.sales_request_id && doc.emission_date) {
              emissionDateMap[doc.sales_request_id] = doc.emission_date;
            }
          });
        }

        setFacturaNumbers(facturaMap);
        setFacturaEmissionDates(emissionDateMap);
      } catch (error) {
        console.error("Error fetching factura numbers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFacturaNumbers();
  }, [orders]);

  const getFacturaNumber = (salesRequestId: string): string => {
    return facturaNumbers[salesRequestId] || "Sin factura";
  };

  const getFacturaEmissionDate = (salesRequestId: string): number | null => {
    return facturaEmissionDates[salesRequestId] || null;
  };

  return {
    facturaNumbers,
    facturaEmissionDates,
    loading,
    getFacturaNumber,
    getFacturaEmissionDate,
  };
};
